import { faChevronDown, faInfo, faLock, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, Transition } from '@headlessui/react';
import { FC, Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useIcaWebsocketContext } from '../../contexts/websocket/IcaWebsocketContext';
import profilePic from '../../images/ProfilePic.svg';
import { authLogout, changeUserPassword } from '../../services/loginService';
import { getErrorMessage, showError } from '../../services/utilities/ServiceError';
import { IAppState } from '../../store/types';
import { logout } from '../../store/user-info/actions';
import { validatePassword } from '../../utilities/Validation';
import AboutModal from '../about/AboutModal';
import CopyrightModal from '../about/CopyrightModal';
import LicenseModal from '../about/LicenseModal';
import Avatar from '../avatar/avatar';
import { useDialog } from '../dialog/DialogContext';
import ChangeUserPasswordModal from "@/components/change-password/change-user-password-modal.tsx";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const AvatarMenu: FC = () => {
    const user = useSelector((state: IAppState) => (state.userInfo));
    const dispatch = useDispatch();
    const icaWebSocket = useIcaWebsocketContext();
    const { translate } = useLocale();
    const [openAbout, setOpenAbout] = useState<boolean>(false);
    const [openCopyright, setOpenCopyright] = useState<boolean>(false);
    const [openLicense, setOpenLicense] = useState<boolean>(false);
    const [openChangePassword, setOpenChangePassword] = useState(false);
    const dialog = useDialog();

    const handleLogout = async (e) => {
        try {
            authLogout(user.id).then(() => {
                icaWebSocket.disposeConnection();
                e.preventDefault()
                dispatch(logout())
            })

        } catch (error) {
            showError(error, toast.warn);
        }
    }

    const aboutModalButtonClick = (buttonClicked: string) => {
        switch (buttonClicked) {
            case "copyright":
                setOpenAbout(false);
                setOpenChangePassword(false);
                setOpenCopyright(true);
                break;
            case "license":
                setOpenAbout(false);
                setOpenChangePassword(false);
                setOpenLicense(true);
                break;
        }
    }

    const onChangePassword = (passwordValues) => {
        changeUserPassword(user.id, passwordValues.newPassword, passwordValues.currentPassword)
            .then(() => {
                toast.success(translate.byKey(TranslationKeys.passwordChangedSuccessfully));
                setOpenChangePassword(false)
            }).catch((error) => {
                dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(error) });
            }).finally(() => {
                setOpenChangePassword(false);
            })
    }

    return (
        <div className="flex flex-row avatar-menu">
            <Menu as="div" className="relative inline-block text-left z-10">
                {({ open }) => (
                    <>
                        <div id='profileBtnId'>
                            <Menu.Button className="px-6 flex flex-row items-center mt-4">

                                {user.masterImage ? <img
                                    className="inline-block h-10 w-10 rounded-full object-cover"
                                    src={`data:image/png;base64,${user.masterImage}`}
                                    alt=""
                                /> : <Avatar />}
                                <FontAwesomeIcon className="pl-2 text-gray-500"
                                    size='lg'
                                    icon={faChevronDown} />
                            </Menu.Button>
                        </div>
                        <Transition
                            show={open}
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items
                                static
                                style={{right: "0.5rem"}}
                                className="origin-top-right absolute mt-2 w-64 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none"
                            >
                                <div className="py-1 m-4">
                                    <span className="flex-shrink-0 group block">
                                        <div className="flex items-center">
                                            <div>   {user.masterImage ? <img
                                                className="inline-block h-16 w-16 rounded-full object-cover"
                                                src={`data:image/png;base64,${user.masterImage}`}
                                                alt=""
                                            /> : <div className="h-16 w-16 flex flex-col justify-center items-center rounded-full bg-gray-500 text-gray-100">
                                                <img className="h-16 w-16 " src={profilePic} alt="" />
                                            </div>}
                                            </div>
                                            <div className="ml-3">
                                                <div
                                                    className={` text-portal-blue-primary text-lg font-semibold`}
                                                    id='usersName'
                                                >
                                                    {user.name}
                                                </div>
                                                <p className="text-sm font-medium text-gray-800 group-hover:text-gray-700" id='usersProfile'>{user.profile}</p>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                {/* <div className="py-1">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <span

                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'group flex items-center px-4 py-2 text-sm'
                                                )}
                                            >
                                                <FontAwesomeIcon icon={faUserCircle} className="mr-3 h-5 w-5 text-gray-900 group-hover:text-gray-500" aria-hidden="true" />
                                                {translate.byKey(TranslationKeys.editMyProfile)}
                                            </span>
                                        )}
                                    </Menu.Item>
                                    <Menu.Item>
                                        {({ active }) => (
                                            <span

                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'group flex items-center px-4 py-2 text-sm'
                                                )}
                                            >
                                                <FontAwesomeIcon icon={faCog} className="mr-3 h-5 w-5 text-gray-900 group-hover:text-gray-500" aria-hidden="true" />
                                                {translate.byKey(TranslationKeys.password)}
                                            </span>
                                        )}
                                    </Menu.Item>
                                    <Menu.Item>
                                        {({ active }) => (
                                            <span
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'group flex items-center px-4 py-2 text-sm'
                                                )}
                                            >
                                                <FontAwesomeIcon icon={faSlidersH} className="mr-3 h-5 w-5 text-gray-900 group-hover:text-gray-500" aria-hidden="true" />
                                                {translate.byKey(TranslationKeys.controls)}
                                            </span>
                                        )}
                                    </Menu.Item>
                                </div>
                                <div className="py-1">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <span

                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'group flex items-center px-4 py-2 text-sm'
                                                )}
                                            >
                                                <FontAwesomeIcon icon={faCalendarAlt} className="mr-3 h-5 w-5 text-gray-900 group-hover:text-gray-500" aria-hidden="true" />
                                                {translate.byKey(TranslationKeys.myHoursWorked)}
                                            </span>
                                        )}
                                    </Menu.Item>
                                    <Menu.Item>
                                        {({ active }) => (
                                            <span
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'group flex items-center px-4 py-2 text-sm'
                                                )}
                                            >
                                                <FontAwesomeIcon icon={faEnvelope} className="mr-3 h-5 w-5 text-gray-900 group-hover:text-gray-500" aria-hidden="true" />
                                                {translate.byKey(TranslationKeys.myNotifications)}
                                            </span>
                                        )}
                                    </Menu.Item>
                                </div> */}
                                <div className="py-1" id='aboutBtnId'>
                                    <Menu.Item key={'about'}>
                                        {({ active }) => (
                                            <button
                                                onClick={(e) => setOpenAbout(true)}
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900 cursor-pointer' : 'text-gray-700',
                                                    'group flex items-center px-4 py-2 text-sm w-full h-full'
                                                )}>
                                                <FontAwesomeIcon icon={faInfo} className="mr-5 h-5 w-5 text-gray-900 group-hover:text-gray-500" aria-hidden="true" />
                                                {translate.byKey(TranslationKeys.about)}
                                            </button>
                                        )}
                                    </Menu.Item>
                                </div>
                                <div className="py-1" id='changePasswordBtnId'>
                                    <Menu.Item key={'changePassword'}>
                                        {({ active }) => (
                                            <button
                                                onClick={(e) => setOpenChangePassword(true)}
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900 cursor-pointer' : 'text-gray-700',
                                                    'group flex items-center px-4 py-2 text-sm w-full h-full'
                                                )}>
                                                <FontAwesomeIcon icon={faLock} className="mr-5 h-5 w-5 text-gray-900 group-hover:text-gray-500" aria-hidden="true" />
                                                {translate.byKey(TranslationKeys.changePassword)}
                                            </button>
                                        )}
                                    </Menu.Item>
                                </div>
                                <div className="py-1" id='logoutBtnId'>
                                    <Menu.Item key={'logout'}>
                                        {({ active }) => (
                                            <button
                                                onClick={(e) => handleLogout(e)}
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900 cursor-pointer' : 'text-gray-700',
                                                    'group flex items-center px-4 py-2 text-sm w-full h-full'
                                                )}>
                                                <FontAwesomeIcon icon={faSignOutAlt} className="mr-3 h-5 w-5 text-gray-900 group-hover:text-gray-500" aria-hidden="true" />
                                                {translate.byKey(TranslationKeys.signOut)}
                                            </button>
                                        )}
                                    </Menu.Item>
                                </div>
                            </Menu.Items>
                        </Transition>
                    </>
                )}
            </Menu>
            <AboutModal isOpen={openAbout} onClose={() => setOpenAbout(false)} aboutModalButtonClick={aboutModalButtonClick} />
            <CopyrightModal isOpen={openCopyright} onClose={() => setOpenCopyright(false)} />
            <LicenseModal isOpen={openLicense} onClose={() => setOpenLicense(false)} />
            <ChangeUserPasswordModal isOpen={openChangePassword} setIsOpen={setOpenChangePassword} onChangePassword={onChangePassword} validateNewPassword={(value) => validatePassword(value, translate)}/>
        </div >
    )
};

export default AvatarMenu;
